import React, { useState, useEffect, Fragment } from "react";
import { Link } from "react-router-dom";

import { editNewsletter } from "../../actions/newsletter";
import { connect } from "react-redux";
import { auth } from "../../actions/auth";
import PropTypes from "prop-types";
import { ToastContainer, toast } from "react-toastify";

import AccountLeftSidebar from "../../components/AccountLeftSidebar/accountLeftSidebar";
import { Button } from "react-bootstrap";
const Newsletter = (props) => {
  const [values, setValues] = useState({
    newsletter: null,
    isChecked: false,
    showSubOption: false,
  });
  /*  constructor(props) {
    super(props);
    values = { newsletter: null };
  } */

  /*   componentDidMount() {
    const user = JSON.parse(localStorage.getItem("user"));
    if (user) {
      setValues({
        newsletter: user.isSubscribe,
      });
    }
  } */
  useEffect(() => {
    const user = JSON.parse(localStorage.getItem("user"));
    if (user) {
      setValues({ ...values, newsletter: user.isSubscribe });
    }
  }, []);
  const _submitHandler = async () => {
    const { newsletter } = values;

    const res = await props.editNewsletter({ newsletter: newsletter });

    if (res) {
      toast(`${res}`, { containerId: "B" });
      await props.auth();
    }
  };
  const handleCheck = () => {
    setValues({
      isChecked: !values.isChecked,
      showSubOption: !values.showSubOption,
    });
  };
  const { newsletter } = values;
  return (
    <Fragment>
      <ToastContainer
        enableMultiContainer
        containerId={"B"}
        position={toast.POSITION.TOP_RIGHT}
      />
      <div className="newsletter-wrapper wrapper-90 max-1600">
        <ul className="breadcrumb">
          <li>
            <Link to="/">
              <i className="fa fa-home" />
            </Link>
          </li>
          <li>
            <Link to="/dashboard"> / Account</Link>
          </li>
          <li>
            <a href="https://sundialhomeproducts.com/index.php?route=account/edit">
              / Newsletter
            </a>
          </li>
        </ul>
        <div className="container-fluid">
          <div className="row">
            <AccountLeftSidebar />
            <div className="col-lg-9 col-md-9 mx-auto">
              <header className="newsletter-header pt-5">
                <h3 className="newsletter-heading">
                  Manage Your Email Preferences
                </h3>
                <div className="newsletter-h-txt">
                  <h5 className="get-subUpdates-txt">
                    Get updates on the topics that interest you
                  </h5>
                  <span className="sub-news-instructions">
                    Please note: It may take up to 48 hours for any changes to
                    be applied. We will continue to send you emails about your
                    shipping, delivery, and order information regardless of your
                    email subscription.
                  </span>
                </div>
              </header>
              <div className="newsletter-content">
                <form className="my-4">
                  <div className="sub-news-daily-weekly">
                    {newsletter !== null && (
                      <div className="col-sm-10">
                        <div className="d-flex flex-row-reverse align-items-center justify-content-end">
                          <div className="subscribe-input-label">
                            <label
                              className="d-flex align-items-center c-pointer m-0"
                              htmlFor="subScribe"
                            >
                              Be the first to know about daily deals,
                              promotions, and other exclusive savings.
                            </label>
                          </div>
                          <div className="p-3 subscribe-input-container">
                            <input
                              className="subscribe-input"
                              id="subScribe"
                              type="checkbox"
                              onChange={handleCheck}
                              defaultChecked={values.isChecked}
                            />
                          </div>
                        </div>
                        <div
                          className={
                            values.showSubOption ? "d-block" : "d-none"
                          }
                        >
                          <h5>How often do you want to receive promotions?</h5>
                          <div>
                            <label className="w-100 text-left btn btn-default d-flex align-items-center">
                              <input
                                type="radio"
                                style={{ position: "static" }}
                                name="newsletter"
                                className="newsSub-radio-btns"
                                defaultValue={newsletter && 1}
                                onChange={() => {
                                  setValues({ ...values, newsletter: true });
                                }}
                                defaultChecked={
                                  newsletter && newsletter === true
                                    ? false
                                    : true
                                }
                              />{" "}
                              &nbsp; Daily
                            </label>
                          </div>
                          <label className="w-100 text-left btn btn-default d-flex align-items-center">
                            <input
                              type="radio"
                              style={{ position: "static" }}
                              name="newsletter"
                              className="newsSub-radio-btns"
                              defaultValue={!newsletter && 1}
                              onChange={() => {
                                setValues({ ...values, newsletter: false });
                              }}
                              defaultChecked={
                                newsletter && newsletter === true ? true : false
                              }
                            />
                            &nbsp; Weekly
                          </label>
                        </div>
                      </div>
                    )}
                  </div>
                </form>
              </div>
              <div className="save-sub-subAll">
                <button
                  className={
                    values.isChecked ? "m-2 sub-all-btn" : "btn-disable"
                  }
                  onClick={values.isChecked ? _submitHandler : null}
                >
                  <span>Save Changes</span>
                </button>
                <Link to="/dashboard" className="d-block w-100 m-2">
                  <button className="save-sub-btn color-white c-pointer">
                    <span>Back</span>
                  </button>
                </Link>
              </div>
            </div>
          </div>
        </div>
      </div>
    </Fragment>
  );
};

editNewsletter.propTypes = {
  editNewsletter: PropTypes.func.isRequired,
};

auth.propTypes = {
  auth: PropTypes.func.isRequired,
};

const mapStateToProps = (state) => ({
  _auth: state.auth,
});

export default connect(mapStateToProps, { editNewsletter, auth })(Newsletter);
